import { render, staticRenderFns } from "./FarmCellRelationTable.vue?vue&type=template&id=0a72e768&scoped=true"
import script from "./FarmCellRelationTable.vue?vue&type=script&lang=js"
export * from "./FarmCellRelationTable.vue?vue&type=script&lang=js"
import style0 from "./FarmCellRelationTable.vue?vue&type=style&index=0&id=0a72e768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72e768",
  null
  
)

export default component.exports